module.exports = {"body":"<h3>Create a Draft Article</h3>\n<ol>\n<li>Go to <a href=\"https://dashcommunity.github.io/blog/compose\">https://dashcommunity.github.io/blog/compose</a></li>\n<li>Write some stuff</li>\n<li>Fill out the <em>Post to GitHub</em> form</li>\n<li>Click the <strong>Post to Github</strong> button</li>\n</ol>\n<h3>Submit your Draft Article to Dash Community for Publishing</h3>\n<ol>\n<li>Step one</li>\n<li>Step two</li>\n<li>Step three</li>\n</ol>\n"}


//////////////////
// WEBPACK FOOTER
// ./articles/drafts/README.md
// module id = 503
// module chunks = 0